export default "__VITE_ASSET__C2lx7boo__"